function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#F2F3F6"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#456673"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.08 9.508h-.008a.572.572 0 100 1.143h8.014a.572.572 0 100-1.143H6.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.651 6.08v-.008a.572.572 0 10-1.141 0v8.014a.57.57 0 101.142 0V6.079z"
})));

function SvgAboutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiNGMkYzRjYiLz4KICAgICAgICA8ZyBmaWxsPSIjNDU2NjczIj4KICAgICAgICAgICAgPHBhdGggZD0iTS41OCA0LjAwOEguNTcyYy0uMzE1IDAtLjU3Mi4yNTUtLjU3Mi41NzEgMCAuMzE2LjI1Ni41NzIuNTcyLjU3Mkg4LjU4NmMuMzE2IDAgLjU3Mi0uMjU2LjU3Mi0uNTcyIDAtLjMxNi0uMjU2LS41NzEtLjU3Mi0uNTcxSC41OHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNSA1LjUpIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik01LjE1MS41OFYuNTcyQzUuMTUxLjI1NiA0Ljg5NSAwIDQuNTggMGMtLjMxNSAwLS41Ny4yNTYtLjU3LjU3MlY4LjU4NmMwIC4zMTYuMjU1LjU3Mi41Ny41NzIuMzE2IDAgLjU3Mi0uMjU2LjU3Mi0uNTcyVi41Nzl6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjUgNS41KSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgAboutIcon as ReactComponent };